import logging from '@sstdev/lib_logging';
export default _private => {
    const { startPromise, mainFileName } = _private;

    return async function purgeDatabase() {
        const loki = await startPromise;

        await new Promise((resolve, reject) => {
            loki.collections.forEach(c => loki.removeCollection(c.name));
            loki.throttledSaveDrain(result => {
                if (!result) {
                    logging.error(
                        'There was a problem purging the database. The existing changes could not be drained.'
                    );
                }
                // This doesn't close the backing store database connection.
                // It just stops auto updates to it.
                loki.close(async err => {
                    if (err) reject(err);
                    await deleteLokiDataFromBackingStore(mainFileName, loki);
                    resolve();
                });
            });
        });
    };

    function deleteLokiDataFromBackingStore(mainFileName, loki) {
        // Delete the lokijs data from the backing store (e.g. indexedDB or sqllite).
        return new Promise((resolve, reject) => {
            try {
                loki.deleteDatabase(result => {
                    // Most lokijs persistence adapters only return a result if there is
                    // an error.  The incrememental-indexeddb adapter returns a result with
                    // success: true if the database was deleted successfully.
                    if (result && !result.success) reject(result);
                    resolve(loki);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
};
